import { render, staticRenderFns } from "./WarningsSettings.vue?vue&type=template&id=d48b1f08&scoped=true"
import script from "./WarningsSettings.vue?vue&type=script&lang=js"
export * from "./WarningsSettings.vue?vue&type=script&lang=js"
import style0 from "./WarningsSettings.vue?vue&type=style&index=0&id=d48b1f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48b1f08",
  null
  
)

export default component.exports